type RetakeItem = {
  category: 'major' | 'minor';
  retakePath?: string;
};

export const openMyResultRetake = (item: RetakeItem, navigate: (path: string) => void) => {
  if (!item.retakePath) {
    return;
  }

  if (item.category === 'major') {
    window.open(item.retakePath, '_blank', 'noopener,noreferrer');
    return;
  }

  navigate(item.retakePath);
};
